<template>
  <div>
    <h4>Modules Manager - FED Service Awards</h4>
    <p>
      Use this screen to determine whether a module/submodule is shown or not in the Admin Menu.
    </p>
    <a-spin :spinning="loading">
      <b-table-simple class="my-3" responsive>
        <b-thead>
          <b-tr>
            <b-th v-for="column in permissionsFields" :key="column.key">{{ column.key }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody v-for="modules in getModulesArrForModuleComp" :key="modules.module_id">
          <b-tr style="background: #ddd">
            <b-td>
              <p>{{ modules.module_name }}</p>
            </b-td>
            <b-td>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  v-model="moduleShow"
                  type="checkbox"
                  role="switch"
                  :value="{ moduleId: modules.module_id }"
                  @change="toggleCheckBox(modules.module_id)"
                />
              </div>
            </b-td>
          </b-tr>
          <b-tr v-for="subModules in modules.sub_modules" :key="subModules.sub_module_id">
            <b-td>
              <p class="mx-2">
                <i class="fa-solid fa-caret-right"></i>
                {{ subModules.sub_module_name }}
              </p>
            </b-td>
            <b-td>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  v-model="subModuleShow"
                  type="checkbox"
                  role="switch"
                  :value="{
                    moduleId: modules.module_id,
                    subModuleId: subModules.sub_module_id,
                  }"
                  @change="toggleCheckBox(modules.module_id, subModules.sub_module_id)"
                />
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </a-spin>
    <b-button class="buttonStyle my-2" variant="primary" @click="updateRoles()"> Update</b-button>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import hrAdminSettingModal from '@/components/hrAdminSettingModal.vue';

export default {
  name: 'AdminSettingsModules',

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: hrAdminSettingModal,
  },

  data() {
    return {
      permissionsFields: [
        {
          key: 'Module / Submodule Name',
          sortable: true,
        },
        {
          key: 'Show / Hide',
          sortable: true,
        },
      ],
      moduleShow: [],
      subModuleShow: [],
      loading: false,
    };
  },

  computed: {
    getModulesArrForModuleComp() {
      return this.$store.getters['settings/getModulesArrForModuleComp'];
    },
    getUserClients() {
      return this.$store.getters['user/getUserClients'];
    },
  },

  watch: {
    getModulesArrForModuleComp(getModulesArrForModuleComp) {
      var moduleShowIds = [];
      var subModuleIds = [];

      getModulesArrForModuleComp.forEach((m) => {
        if (m.is_active === true) {
          moduleShowIds.push({ moduleId: m.module_id });
          m.sub_modules.forEach((s) => {
            if (s.is_active === true) {
              subModuleIds.push({
                moduleId: m.module_id,
                subModuleId: s.sub_module_id,
              });
            }
          });
        }
      });

      this.moduleShow = moduleShowIds;
      this.subModuleShow = subModuleIds;
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'modules',
        activeMenu: this.activeMenu ? this.activeMenu : 'settings',
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    toggleCheckBox(moduleId, subModuleId = null) {
      if (subModuleId != null) {
        // trigerred from submodule
        var subModuleShowTemp = this.subModuleShow.filter((v) => {
          return v.moduleId === moduleId;
        });

        if (subModuleShowTemp.length) {
          this.moduleShow.push({ moduleId });
        } else {
          this.moduleShow = this.moduleShow.filter((v) => {
            return v.moduleId != moduleId;
          });
        }
      }
    },
    updateRoles() {
      var moduleDetails = this.subModuleShow.reduce((arr, { moduleId, subModuleId }) => {
        arr[moduleId] = arr[moduleId] || { moduleId, subModuleId: [] };
        arr[moduleId]['subModuleId'].push(subModuleId);
        return arr;
      }, {});

      moduleDetails = Object.values(moduleDetails);

      moduleDetails.map((v) => {
        v.module_id = v.moduleId;
        v.sub_modules = v.subModuleId;
        delete v.moduleId;
        delete v.subModuleId;
      });

      var params = {
        client_id: +this.getUserClients.client,
        module_details: moduleDetails,
      };
      this.loading = true;
      this.$store
        .dispatch('settings/updateRolesForModules', params)
        .then(() => {
          this.$store.commit('systemMessage/SET_MODAL_MESSAGE', 'Successfully updated.');
          this.scrollToTop();
          this.$store.dispatch('settings/fetchAllModules');
          this.loading = false;
        })
        .catch(() => {
          console.log('error from updateRoles');
        });
    },
  },

  created() {
    this.setActiveMenuItem();
    this.$store.dispatch('settings/fetchAllModules');
  },
};
</script>
<style lang="scss" scoped>
.settings {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    // padding: 6px 8px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}

.buttonStyle {
  border-radius: 1.5rem;
}
</style>
